import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ChangePasswordService } from './change-password.service';
import { NavigationStart, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  isLoading: Subject<boolean> = new Subject<boolean>();
  passwordForm: FormGroup
  public inputCurrentPass: string = 'password'
  public inputNewPass: string = 'password'
  public inputConfirmPass: string = 'password'
  flag: any
  constructor(private passwordService: ChangePasswordService, private router: Router, private toastr: ToastrService, private fb: FormBuilder) {
    this.router.events
      .subscribe((event: any) => {
        if (event instanceof NavigationStart) {
          sessionStorage.setItem('previousUrl', this.router.url)
        }
      });


    this.passwordForm = this.fb.group({
      currentPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.pattern('^(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*])[A-Za-z\\d!@#$%^&*]{8,}$')]],
    })
  }
  get f() { return this.passwordForm.controls; }

  previousUrl: any = ''
  ngOnInit() {
    if (sessionStorage.getItem('previousUrl')) {
      this.previousUrl = sessionStorage.getItem('previousUrl')
      console.log(this.previousUrl.split('/'))
      const selectedItem = document.getElementById(this.previousUrl.split('/')[2]);
      if (selectedItem) {
        selectedItem.classList.add('active');
      }
    }
  }


  submitted: boolean = false;
  setPassword() {
    this.submitted = true;
    if (this.passwordForm.invalid) {
      return;
    } else {
      let request = {
        "current_password":this.passwordForm.value.currentPassword,
        "password":this.passwordForm.value.newPassword,
        "cpassword":this.passwordForm.value.confirmPassword
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.passwordService.setPassword(request).subscribe((response: any) => {
        if (response.body.responseCode === 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success(response.body.responseMessage)
          this.submitted = false;
          this.passwordForm.reset();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(response.body.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    }
  }

  public isHideCurrent: boolean = true;
  public isShowCurrent: boolean = false;
  passwordCurrent(fieldname: any) {
    if (fieldname === 'show') {
      this.isShowCurrent = false;
      this.isHideCurrent = true;
      this.inputCurrentPass = 'password'
    }
    else {
      this.isShowCurrent = true;
      this.isHideCurrent = false;
      this.inputCurrentPass = 'text'
    }
  }

  public isHideConfirm: boolean = true;
  public isShowConfirm: boolean = false;
  passwordConfirm(fieldname: any) {
    console.log(fieldname)
    if (fieldname === 'show') {
      this.isShowConfirm = false;
      this.isHideConfirm = true;
      this.inputConfirmPass = 'password'
    }
    else {
      this.isShowConfirm = true;
      this.isHideConfirm = false;
      this.inputConfirmPass = 'text'
    }
  }

  public isHideNew: boolean = true;
  public isShowNew: boolean = false;
  passwordNew(fieldname: any) {
    if (fieldname === 'show') {
      this.isShowNew = false;
      this.isHideNew = true;
      this.inputNewPass = 'password'
    }
    else {
      this.isShowNew = true;
      this.isHideNew = false;
      this.inputNewPass = 'text'
    }
  }
}
